import { useQuery } from "@tanstack/react-query";
import { WalletService, WithdrawalResponse } from "@/services/wallet.service";
import { useTranslation } from "react-i18next";

export const useFetchWithdrawal = ({
  currentPage,
  enabled = true,
  currency,
}: {
  currentPage?: number;
  enabled?: boolean;
  currency: string;
}) => {
  const { t } = useTranslation('common');
  const {
    data: withdrawal,
    isPending: isLoading,
    refetch,
    isRefetching,
    error,
  } = useQuery<WithdrawalResponse>({
    queryKey: ['wallet-withdrawal', currentPage, currency],
    queryFn: async () =>
      await WalletService.getWithdrawal({ currentPage, currency }),
    enabled,
  });

  return {
    withdrawal,
    isLoading,
    refetch,
    isRefetching,
    error: error ? (error as Error).message || t('data_listing_error') : null,
  };
};
